import CloseIcon from 'components/header/icons/CloseIcon'

interface IProps {
  text: string
  handleClick?: () => void
  closeBool?: boolean
}

const Arrow = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 12H5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 19L5 12L12 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

const Breadcrumb = ({ text, handleClick, closeBool }: IProps) => {
  return (
    <div className="breadcrumb">
      <div className='flex gap-2'>
        <button onClick={handleClick} className="breadcrumb__btn" type='button'>
          <Arrow />
        </button>

        <p className="breadcrumb__title">{text}</p>
      </div>

      {
        closeBool && (
          <button className='menu__container__close' onClick={handleClick}>
            <CloseIcon />
          </button>
        )
      }
    </div>
  )
}

export default Breadcrumb
